import { Component, OnInit } from '@angular/core';
import { EnterpriseService } from '../enterprise.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-enterprise-helping-business',
  templateUrl: './helping-business.component.html',
  styleUrls: ['helpin-business.component.scss'],
  imports: [CommonModule],
})
export class EnterpriseHelpingBusinessComponent implements OnInit {
  helpingBusinessData:any;
  constructor(
    private enterpriseService: EnterpriseService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router
  ) {
    this.getUrl = this.router.url;
  }

  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    let data = this.route.snapshot.data?.['seo']?.[0].fields;
    this.helpingBusinessData = data?.otherBenefits?.fields;
  }
}
